import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import styles from "./styles.css";
import Gallery from "../../components/gallery";
import Pagination from "../../components/pagination";
import { fetchMediaData } from "../../utilities/fetch-media-data";
import { useUgcContext } from "../../context/user-generated-content";
import { setContentList, setPaginationLinks } from "../../state/user-generated-content/reducer";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";
import Headroom from "react-headroom";
import { trackPageEvent } from "../../utilities/trackPageEvent";
;
const GalleryLayout = ({ countPerPage, categoryId }) => {
    const [state, dispatch] = useUgcContext();
    const { contentList, pagination } = state;
    const headerRef = useRef(null);
    const [elementToFocus, setElementToFocus] = useState(0);
    const translate = useTranslate(useLocaleProvider());
    const [pageNumber, setPageNumber] = useState(0);
    const [ctaRef, setCtaRef] = useState("");
    const handleViewMore = async () => {
        const paginationCursor = pagination.next;
        const response = await fetchMediaData(paginationCursor, countPerPage, categoryId);
        dispatch(setContentList([...contentList, ...response.media]));
        dispatch(setPaginationLinks(response.cursor));
        setElementToFocus(contentList.length > 0 ? (contentList.length + 1) : 0);
        setPageNumber((prevPageNumber) => prevPageNumber + 1);
    };
    useEffect(() => {
        if (elementToFocus > 0) {
            document.querySelector(`.gallery_content li:nth-of-type(${elementToFocus}) > a`).focus();
        }
    }, [elementToFocus]);
    useEffect(() => {
        if (window !== undefined && window.location.hash) {
            const hashCtaRefValue = decodeURI(window.location.hash?.split("#ctaref=")[1]);
            setCtaRef(hashCtaRefValue);
            history.replaceState("", document.title, `${window.location.pathname}${window.location.search}`);
            trackPageEvent(pageNumber, hashCtaRefValue);
        }
        else {
            trackPageEvent(pageNumber, ctaRef);
        }
    }, [pageNumber]);
    return (_jsxs("div", { className: styles.container, children: [_jsx(Headroom, { className: styles.stickyHeader, disableInlineStyles: true, pinStart: 80, upTolerance: 17, children: _jsxs("div", { className: styles.title, ref: headerRef, children: [_jsx("h1", { className: "app_barnsley5", children: translate("ugc_gallery_title") }), _jsx("p", { className: "app_leavesden2", children: translate("ugc_gallery_subtitle") })] }) }), _jsxs("div", { className: styles.contentContainer, children: [_jsx(Gallery, { mediaList: contentList, countPerPage: countPerPage, ctaRef: ctaRef }), _jsx(Pagination, { count: contentList.length, handleNextPage: handleViewMore, hasNextPage: !!pagination?.next })] })] }));
};
export default GalleryLayout;
